import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Color, Colors } from '../styles/Colors';
import { AgendaContext } from '../context/AgendaContext';
import SwicthButton from './SwicthButton';
import { Trans, useTranslation } from 'react-i18next';
const ItemsWrapper = styled.div`
  & > div {
    display: flex; 
  }

  & > div > span {
    flex: 1; 
  }

  & > div > span:nth-of-type(2) {
    flex: 2; 
    padding: 0 .5rem 0 .5rem; 
  }
  
  @media (max-width: 1150px) {
    & > div > span:nth-of-type(2) {
      flex: 1; 
    }
  }
`;
const AttendingOptions = styled.div`
  display: flex; 
`;
const Option = styled.div`
  display: flex;
  justify-content: flex-start; 
  align-items: center; 
  margin: 0 0.5rem 0 0; 
  
  // Add space inbetween (margin-left) the label and the input - checked or radiobutton
  & > label {
    margin: 0 8px 0 0; 
    font-weight: 400;
  }
`;
const Note = styled.span`
  display: flex; 
  flex-direction: row; 
  & > p:first-of-type {
    padding: 0 4px 0 0; 
  }
  color: 
    ${({$note}) => (
      $note === 'leaving' 
        ? Color(Colors.red) 
        : $note === 'new'
          ? Color(Colors.green)  
          : Color(Colors.black)
    )}; 
`;

const HideWrapper = styled.div`
  padding: 0 0 1rem 0; 
  dispaly: flex; 
  align-items: center; 
  justify-content: flex-start; 

  & > p {
    padding: 0 .5rem 0 0; 

    & > span {
      font-style: italic; 
    }
  }
`; 

const Participants = () => {
  const { t } = useTranslation(); 
  const { participants, setParticipants, participantsIsOpened, setParticipantsIsOpened } = useContext(AgendaContext);

  useEffect(() => {
    const getItem = JSON.parse(localStorage.getItem('participant')) || [];
    const mergedParticipants = participants.map((participant) => {
      const savedParticipant = getItem.find(item => item.id === participant.id);
      return savedParticipant ? { ...participant, ...savedParticipant } : participant; 
    });
    setParticipants(mergedParticipants);
  }, []); 
  
  const handleAttending = (id) => {
    setParticipants((prevParticipant) => {
      const updatedParticipants = prevParticipant.map((participant) =>
        participant.id === id ? { ...participant, absent: !participant.absent } : participant
      );

      const getItem = JSON.parse(localStorage.getItem('participant')) || [];
      const updatedItem = updatedParticipants.find(participant => participant.id === id);

      if (updatedItem.absent) {
        const participantIndex = getItem.findIndex(item => item.id === id);
        if (participantIndex >= 0) {
          getItem[participantIndex] = updatedItem; // Update the existing member
        } else {
          getItem.push(updatedItem); // Add new member if not already present
        }
      } else {
        const participantIndex = getItem.findIndex(item => item.id === id);
        if (participantIndex >= 0) {
          getItem.splice(participantIndex, 1); // Remove member if absent is false
        }
      }
      localStorage.setItem('participant', JSON.stringify(getItem));
      return updatedParticipants;
    });
  };

  const toggleAttendant = (event) => {
    const checked = event.target.checked; 

    setParticipantsIsOpened(checked)
    localStorage.setItem('participants_is_open', JSON.stringify(checked)); 

    if (!checked) {
      setParticipants((prevParticipants) => 
        prevParticipants.map((participant) => ({...participant, absent: false}))
      ); 
      
      localStorage.removeItem('participant'); 
    }
  }; 

  return (
    <div>
      {participants && participants.length > 0 && (
        <ItemsWrapper>
          <HideWrapper>
            <p>
              {participantsIsOpened ? `${t('common.hideSection')} ` : `${t('common.showSection')} `}
              <Trans 
                i18nKey='participants.showTable'
                components={{
                  italic: <i key="italic" />,
                  bold: <strong key="bold" />
                }}
              />
            </p>
            <SwicthButton 
              checked={participantsIsOpened}
              onChange={toggleAttendant}
            />
          </HideWrapper>
          <div style={{ padding: '0 0 1rem 0' }}>
            <span>{t('participants.tableHeadTitles.name')}</span>
            <span>{t('participants.tableHeadTitles.organization')}</span>
            <span>{t('participants.tableHeadTitles.present')}</span>
          </div>
          {participants.map((item) => (
            <div key={item.id}> 
              <Note $note={item.note}>
                <p>{item.name}</p>
                {item.note === 'leaving'
                  ? <p>{`(${t('participants.resigned')})`}</p>
                  : item.note === 'new'
                    ? <p>{`(${t('participants.joined')})`}</p>
                    : ''
                }
              </Note>
              <span>{item.organization}</span>
              <span>
                {participantsIsOpened && (
                  <AttendingOptions>
                    <Option>
                      <label>{`${t('participants.apologies')}:`}</label> 
                      <input 
                        type='checkbox'
                        name={`absent-${item.id}`}
                        checked={item.absent}
                        onChange={() => handleAttending(item.id)}
                      />
                    </Option>
                  </AttendingOptions>
                )}
              </span>
            </div>
          ))}
        </ItemsWrapper>
      )}
    </div>
  );
};
export default Participants;